// extracted by mini-css-extract-plugin
export default {"login-form":"login_login-form__6+6gi"};